// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import type { ButtonProps } from '@mui/material/Button';

export enum RequestType {
  Mint = 'Mint',
  Burn = 'Burn',
  Transfer = 'Transfer',
}

export enum RequestState {
  Offered = 'Offered',
  Failed = 'Failed',
  Rejected = 'Rejected',
  Executed = 'Executed',
  Requested = 'Requested',
}

export interface RowNew {
  contractId: string;
  instrumentId: string;
  createdAt: string;
  reason?: string;
  receiver: string;
  sender: string;
  operator: string;
  provider: string;
  registrar: string;
  amount: string;
  reference?: string;
  requestType: RequestType;
  requestState: RequestState;
  executeBefore?: string;
  isThreeStep?: boolean;
  isInterface?: boolean;
  holdingLabel?: string;
}

export type Action<RowType = unknown> = {
  name: string;
  color: ButtonProps['color'];
  action: (row: RowType) => Promise<unknown>;
};
